/**
 * Destino pós-login vindo de `?next=`.
 *
 * **Somente caminhos internos.** Um `?next=` aceito sem validação é um open
 * redirect: bastaria mandar `/entrar?next=https://site-clonado.com` para alguém
 * entrar no produto de verdade e ser jogado numa cópia que pede a senha de
 * novo. A regra é simples e fechada — tem de começar com uma barra e não pode
 * começar com duas, nem com `/\`, que viram URL protocolo-relativa.
 */
export const DEFAULT_AFTER_LOGIN = '/inicio';

export function safeNextPath(raw: string | null | undefined): string {
  if (!raw) return DEFAULT_AFTER_LOGIN;

  // Decodifica uma vez: `%2f%2fsite.com` também é protocolo-relativo.
  let value = raw;
  try {
    value = decodeURIComponent(raw);
  } catch {
    return DEFAULT_AFTER_LOGIN;
  }

  if (!value.startsWith('/')) return DEFAULT_AFTER_LOGIN;
  if (value.startsWith('//') || value.startsWith('/\\')) return DEFAULT_AFTER_LOGIN;
  // Backslash é normalizado para barra por vários navegadores.
  if (value.includes('\\')) return DEFAULT_AFTER_LOGIN;
  if (value.includes('://')) return DEFAULT_AFTER_LOGIN;

  return value;
}

/** Monta o link de login preservando para onde a pessoa queria ir. */
export function loginPathFor(location: { pathname: string; search: string }): string {
  const target = `${location.pathname}${location.search}`;
  if (target === '/entrar' || target.startsWith('/entrar?')) return '/entrar';
  return `/entrar?next=${encodeURIComponent(target)}`;
}
